import useAnalytics from "hooks/useAnalytics";

import { ANALYTICS } from "./constants";

const useBlueprintTemplateBodyAnalytics = () => {
  return useAnalytics({
    page: ANALYTICS.analyticsPage,
  });
};

export default useBlueprintTemplateBodyAnalytics;
